import { render } from "./lens.vue?vue&type=template&id=365e45d6&scoped=true"
import script from "./lens.vue?vue&type=script&lang=js"
export * from "./lens.vue?vue&type=script&lang=js"

import "./lens.vue?vue&type=style&index=0&id=365e45d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-365e45d6"

export default script